import { cn } from "@/lib/utils";

const TONE = {
  "Delivered": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "In Transit": "bg-blue-50 text-blue-700 border-blue-200",
  "Out for Delivery": "bg-blue-100 text-blue-800 border-blue-300",
  "Not Picked Up": "bg-amber-50 text-amber-800 border-amber-200",
  "RTO": "bg-amber-100 text-amber-900 border-amber-300",
  "No Update": "bg-amber-50 text-amber-700 border-amber-200",
  "Undelivered / NDR": "bg-red-50 text-red-700 border-red-200",
  "Not Shipped / No AWB": "bg-red-50 text-red-700 border-red-200",
};

export const StatusPill = ({ status, testid }) => (
  <span data-testid={testid} className={cn("inline-flex items-center whitespace-nowrap rounded-full border px-2 py-0.5 text-[11px] font-semibold",
    TONE[status] || "bg-slate-100 text-slate-600 border-slate-200")}>{status}</span>
);

export const COURIERS = ["Delhivery", "Blue Dart", "Amazon ATS", "Amazon FBA", "Tekipost", "PickupXpress", "Self Ship"];

export const TILES = [
  ["need_action", "Need action", "text-amber-700"], ["late", "Late", "text-red-600"], ["ndr", "Undelivered / NDR", "text-red-600"],
  ["not_picked", "Not picked up", "text-amber-700"], ["rto", "RTO", "text-amber-800"], ["in_transit", "In transit", "text-blue-700"],
  ["ofd", "Out for delivery", "text-blue-800"], ["delivered", "Delivered", "text-emerald-700"], ["all", "All", "text-slate-700"],
];

export const LateCell = ({ days }) => (days ? <span className={cn("font-mono font-bold", days > 7 ? "text-red-600" : "text-amber-700")}>{days}</span> : <span className="text-muted-foreground">—</span>);

export const ActionTag = ({ action }) => (action ? (
  <span className="inline-block rounded bg-amber-400/20 px-1.5 py-0.5 text-[11px] font-semibold text-amber-900">{action}</span>
) : null);
